import { TEXT_200 } from 'style/constants';
import { TEXT_LABEL_M_MEDIUM } from 'style/design-system/textStyles';
import styled from 'styled-components';

export const DateLabel = styled.label`
  color: ${TEXT_200};
  ${TEXT_LABEL_M_MEDIUM}
`;
